const configuredSupabaseUrl = import.meta.env.VITE_SUPABASE_URL?.replace(/\/$/, "");
const DEFAULT_EDGE_FUNCTIONS_BASE = configuredSupabaseUrl
  ? `${configuredSupabaseUrl}/functions/v1`
  : "";

const EDGE_FUNCTIONS_BASE = (
  import.meta.env.VITE_INSTALLER_DOWNLOAD_BASE_URL ||
  DEFAULT_EDGE_FUNCTIONS_BASE
).replace(/\/$/, "");

function getEdgeFunctionsBase(): string {
  if (!EDGE_FUNCTIONS_BASE) {
    throw new Error("Missing installer download service configuration");
  }

  return EDGE_FUNCTIONS_BASE;
}

export interface InstallerAsset {
  name: string;
  size: number;
  content_type: string;
  download_url: string;
}

export interface InstallerRelease {
  tag_name: string;
  name: string;
  published_at: string;
  draft: boolean;
  prerelease: boolean;
  assets: InstallerAsset[];
}

export function buildInstallerDownloadUrl(tag: string, filename: string): string {
  const normalizedTag = tag.startsWith("v") ? tag : `v${tag}`;
  return `${getEdgeFunctionsBase()}/download-installer/${encodeURIComponent(normalizedTag)}/${encodeURIComponent(filename)}`;
}

export async function fetchLatestInstallerRelease(): Promise<InstallerRelease> {
  const response = await fetch(`${getEdgeFunctionsBase()}/release-info`, {
    headers: { Accept: "application/json" },
    credentials: "omit",
  });

  if (!response.ok) {
    throw new Error(`Release service returned ${response.status}`);
  }

  return response.json() as Promise<InstallerRelease>;
}
